import request from "@/utils/request_old";

function commonQuery(data) {
  return request({
    url: "/dataAccessQueryController/commonQuery",
    method: "GET",
    params: data,
    cancelToken: data.cancelToken,
  });
}

function commonPageQuery(data) {
  return request({
    url: "/datafill/commonQueryController/commonPageQuery",
    method: "GET",
    params: data,
  });
}

function commonPost(url, param) {
  return request({
    url: url || "/datafill/commonQueryController/commonQuery",
    method: "POST",
    params: param,
  });
}

function commonPostData(url, data) {
  return request({
    url: url || "/datafill/commonQueryController/commonQuery",
    method: "POST",
    data: data,
  });
}

export default {
  commonQuery,
  commonPost,
  commonPageQuery,
  commonPostData,
};
